export const getToken = () => localStorage.getItem("token");
export const cmsPrefix = `${process.env.REACT_APP_API_URL}/cms/${process.env.REACT_APP_API_VERSION}`;
export const apiPrefix = `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}`;
